import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  Optional,
  Inject,
  NgZone,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HttpClientModule,
  HttpClientJsonpModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

// application
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageComponent } from './components/page/page.component';
import { PageItemComponent } from './components/page-item/page-item.component';
import { ErrorComponent } from './components/error/error.component';
import { EdcWrapperComponent } from './components/edc-wrapper-component/edc-wrapper.component';
import { OrderProspectusWrapperComponent } from './components/order-prospectus-wrapper-component/order-prospectus-wrapper.component';
import { DummyRefreshComponent } from './components/dummy-refresh/dummy-refresh.component';

// material
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

// common
import { PerNgPlatformServiceModule } from '@pershing/per-ng-platform-service';
import {
  PershingCoreRootModule,
  PershingTranslationService,
} from '@pershing/pershing-core';
import { NxiNgCommonModule } from '@pershing/nxi-ng-common';
import { NxiModernNavigationModule } from '@pershing/nxi-ng-modern-navigation';
import { PortalComponentsModule } from '@pershing/nxi-portalcomponents';
import { ModernAlertsModule } from '@pershing/nxi-ng-modern-alerts';
import { ModPreloginModule } from '@pershing/nxi-ng-mod';
import { ModernIdentityVerificationModule } from '@pershing/nxi-ng-verid';

// third party
import { DynamicModule } from 'ng-dynamic-component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { BackendInterceptor } from './interceptors/backend.interceptor';
import { AuthService } from './services/auth.service';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

  declarations: [
    AppComponent,
    PageComponent,
    PageItemComponent,
    ErrorComponent,
    EdcWrapperComponent,
    OrderProspectusWrapperComponent,
    DummyRefreshComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    MatIconModule,
    MatToolbarModule,
    MatListModule,
    MatMenuModule,
    MatButtonModule,
    DynamicModule,
    PerNgPlatformServiceModule,
    PershingCoreRootModule,
    NxiNgCommonModule,
    NgIdleKeepaliveModule.forRoot(),
    AppRoutingModule,
    NxiModernNavigationModule,
    ModernIdentityVerificationModule,
    PortalComponentsModule,
    ModernAlertsModule,
    ModPreloginModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: BackendInterceptor, multi: true },
    { provide: 'AppSettings', useValue: (window as any).pershingAppSettings },
    PershingTranslationService,
    AuthService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    private translationService: PershingTranslationService,
    @Optional() @Inject('AppSettings') appSettings: any,
    private ngZone: NgZone
  ) {
    (window as any).ngZone = this.ngZone;
    if (this.translationService) {
      // Set the translation path for this module
      let i18nPath = 'node_modules/@pershing/nxi-ng-shell/assets';
      let i18nModule = '@pershing/nxi-ng-shell';

      // overide the translation path to load from assets folder for local development
      if (appSettings && appSettings.isForLocal) {
        i18nPath = 'http://localhost:8085/assets';
      }

      let translationArray = [i18nPath];

      console.log('loading translations from: ', translationArray);
      this.translationService.addTranslationFolders(
        i18nModule,
        translationArray
      );
    }
  }
}
